module.exports = __webpack_public_path__ + "static/media/gh.d0289dc0.png";